document.addEventListener("DOMContentLoaded", function () {
	const slideInItems = document.querySelectorAll(".slide-up-animated");
	if (!slideInItems) return;
	slideInItems.forEach((item) => {
		item.classList.add("animation-start");
	});
});
function getSliderSettings() {
  return {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-btn--next",
      prevEl: ".swiper-btn--prev",
    },
    thumbs: {
      swiper: document.querySelector(".js-media-sublist").swiper,
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: 5,              // show 5 thumbs at once
    spaceBetween: 10,              // spacing between thumbs
    direction: "horizontal",       // switch to horizontal layout
    watchSlidesProgress: true,     // keep sync with main slider
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".swiper-btn--next", // make sure these exist in your Liquid
      prevEl: ".swiper-btn--prev",
    },
    breakpoints: {                 // responsive control
      320: { slidesPerView: 3 },
      768: { slidesPerView: 5 },
    },
  };
}

function updatethumbnail() {
	if (document.querySelector(".quick-add-modal .product__media-list")) {
		let productList = document.querySelector(
			".quick-add-modal .product__media-list"
		);
		let mediaHeight = productList && productList.offsetHeight;
		let mediaThumbHeight = document.querySelector(
			".quick-add-modal .product__media-sublist"
		);
		if (mediaThumbHeight) {
			if (window.innerWidth > 576) {
				mediaThumbHeight.style.height = mediaHeight + "px";
			}
			if (window.innerWidth < 576) {
				mediaThumbHeight.style.height = 100 + "%";
			}
		}
	}
	// else {
	//	let productList = document.querySelector(
	//		".product-section .product__media-list"
	//	);
	//	let mediaHeight = productList && productList.offsetHeight;
	//	console.log("productList.offsetHeight --- " + productList.offsetHeight);
	//	console.log("mediaHeight --- " + mediaHeight);

	//	let mediaThumbHeight = document.querySelector(
	//		".product-section .product__media-sublist"
	//	);
	//	if (mediaThumbHeight) {
	//		if (window.innerWidth > 576) {
	//			mediaThumbHeight.style.height = mediaHeight + "px";
	//		}
	//		if (window.innerWidth < 576) {
	//			mediaThumbHeight.style.height = 100 + "%";
	//		}
	//	}
	//}
}

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list") &&
		document.querySelectorAll(".js-media-list").length > 0
	) {
		document.querySelectorAll(".js-media-list").forEach((elem, index) => {
			let slider = new Swiper(elem, {
				slidesPerView: 1,
				//autoHeight: true,
				spaceBetween: 24,
				navigation: {
					nextEl: ".swiper-btn--next",
					prevEl: ".swiper-btn--prev",
				},
				thumbs: {
					swiper: document.querySelectorAll(".js-media-sublist")[index].swiper,
				},
				on: {
					slideChangeTransitionStart: function () {
						document
							.querySelectorAll(".js-media-sublist")
							[index].swiper.slideTo(
								document.querySelectorAll(".js-media-list")[index].swiper
									.activeIndex
							);
					},
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							this.slides[this.activeIndex]
								.querySelector(".shopify-model-viewer-ui__button--poster")
								.removeAttribute("hidden");
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							if (
								!this.slides[this.activeIndex]
									.querySelector("model-viewer")
									.classList.contains("shopify-model-viewer-ui__disabled")
							) {
								this.params.noSwiping = true;
								this.params.noSwipingClass = "swiper-slide";
							} else {
								this.params.noSwiping = false;
							}
						}
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					slider.update();
					updatethumbnail();
				}, 800);
			}
		});
	}
};

const subSliderInit = (isUpdate, slidesPerView = 7, spaceBetween = 16) => {
	if (
		document.querySelectorAll(".js-media-sublist") &&
		document.querySelectorAll(".js-media-sublist").length > 0
	) {
		document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
			let isCenteringEnabled = true;

			let subSlider = new Swiper(elem, {
				centeredSlides: true,
				centeredSlidesBounds: true,
				spaceBetween: spaceBetween,
				//slideToClickedSlide: true,
				//watchSlidesProgress: true,
				//updateOnWindowResize: true,
				slidesPerView: 3,
				direction: "horizontal",
				navigation: false,
				freeMode: false,
				initialSlide: 0,
				on: {
					init: function () {
						this.setTranslate(0, 0, 0);
					},
				},
				transitionStart: function () {
					document
						.querySelector(".js-media-list")
						.swiper.slideTo(
							document.querySelectorAll(".js-media-sublist")[index].swiper
								.activeIndex
						);
				},
				breakpoints: {
					576: {
						direction: "vertical",
						slidesPerView: slidesPerView - 0.5,
					},
					750: {
						direction: "vertical",
						slidesPerView: slidesPerView + 1.5,
					},
					990: {
						direction: "vertical",
						slidesPerView: slidesPerView - 0.5,
					},
					1200: {
						direction: "vertical",
						slidesPerView: slidesPerView,
					},
					//1360: {
					//	direction: "vertical",
					//	slidesPerView: slidesPerView - 0.5,
					//},
					1360: {
						direction: "vertical",
						slidesPerView: slidesPerView,
					},
				},
			});

			const checkSlidesAndUpdate = () => {
				if (subSlider.slides.length <= slidesPerView) {
					if (isCenteringEnabled) {
						subSlider.params.centeredSlides = false;
						subSlider.update();
						isCenteringEnabled = false;
					}
				} else {
					if (!isCenteringEnabled) {
						subSlider.params.centeredSlides = true;
						subSlider.update();
						isCenteringEnabled = true;
					}
				}
			};

			checkSlidesAndUpdate();

			subSlider.on("toEdge", checkSlidesAndUpdate);

			const resizeObserver = new ResizeObserver(() => {
				const sliders = document.querySelectorAll(".js-media-list");
				const sliderHeight = sliders[index]?.getBoundingClientRect().height;
				if (sliderHeight) {
					elem.style.height = `${sliderHeight - 1}px`;
				}
			});

			const productSection =
				document.querySelector('.product-section') ||
				document.querySelector('.quick-add-modal');

			if (productSection) {
				resizeObserver.observe(productSection);
			}

			if (isUpdate) {
				setTimeout(() => {
					subSlider.update();
				}, 800);
			}
		});
	}
};

let allSections = document.querySelectorAll("section");

window.addEventListener("resize", () => {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

document.addEventListener("visibilitychange", function () {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		document
			.getElementById("MenuDrawer-Overlay")
			.addEventListener("click", this.closeMenuDrawerOverlay);
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	closeMenuDrawerOverlay() {
		document
			.querySelector(".menu-drawer-container")
			.classList.remove("menu-opening");

		document.querySelector(".menu-drawer-container").removeAttribute("open");
		document
			.querySelector(".header__icon--menu")
			.setAttribute("aria-expanded", false);
		document.body.classList.remove(
			`overflow-hidden-${this.dataset.breakpoint}`
		);
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom"
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class BurgerDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#BurgerDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);

		this.querySelector("#burger-drawer-close").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#burger-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = document.getElementById("BurgerDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".burger__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("burger-drawer", BurgerDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this)
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);
			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute("data-autoplay")) {
							let playPromise = entry.target.play();
							if (playPromise !== undefined) {
								playPromise.then((_) => {}).catch((error) => {});
							}
						}
					} else {
						entry.target.pause();
					}
				});
			});
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);

			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				// force autoplay for safari

				if (this.classList.contains("video-section__media")) {
					let playPromise = deferredElement.play();
					if (playPromise !== undefined) {
						playPromise.then((_) => {}).catch((error) => {});
					}
					videoObserver.observe(deferredElement);
				} else {
					deferredElement.play();
				}
			}
			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class CardDeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.loadContent();
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);

			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute("data-autoplay")) {
							let playPromise = entry.target.play();
							if (playPromise !== undefined) {
								playPromise.then((_) => {}).catch((error) => {});
							}
						}
						entry.target.play();
					} else {
						entry.target.pause();
					}
				});
			});

			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);

			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				deferredElement.autoplay = true;
				deferredElement.muted = true;
				deferredElement.play();

				let playPromise = deferredElement.play();
				if (playPromise !== undefined) {
					playPromise.then((_) => {}).catch((error) => {});
				}
				videoObserver.observe(deferredElement);
			}
		}
	}
}

customElements.define("card-deferred-media", CardDeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		if (!this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			//this.updateMediaSub();
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort();
				variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem);
		return styles.display === "none" || styles.visibility === "hidden";
	}
	updateMedia() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);
		const parent = newMedia.parentElement;

		const swiperWrappers = document.querySelectorAll(".product__media-wrapper, .global-variant-slider");


		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
				);
				const mediaList = elem.querySelector(".js-media-list, .global-variant-js-media-list");

				if (mediaList) {
					mediaList.swiper.slideTo(
						mediaList.swiper.slides.indexOf(newMedia)
					);
				} else {
					newMedia && parent.prepend(newMedia);

					window.setTimeout(() => {
						parent.scroll(0, 0);
					});
				}
				//if (elem.querySelector(".js-media-list")) {
				//	elem
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			elem
				//				.querySelector(".js-media-list")
				//				.swiper.slides.indexOf(newMedia)
				//		);
				//}
			}
		});
	}

	//updateMedia() {
	//	if (!this.currentVariant || !this.currentVariant?.featured_media) return;

	//	const newMedia = document.querySelector(
	//		`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
	//	);

	//	if (!newMedia) return;

	//	const parent = newMedia.parentElement;

	//	parent.prepend(newMedia);

	//	window.setTimeout(() => {
	//		parent.scroll(0, 0);
	//	});

	//	if (document.querySelector(".js-media-list")) {
	//		sliderInit();
	//	}
	//}

	//updateMediaSub() {
	//	if (!this.currentVariant || !this.currentVariant?.featured_media) return;

	//	const newMediaSub = document.querySelector(
	//		`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
	//	);

	//	if (
	//		document.querySelector(".js-media-sublist") &&
	//		document.querySelector(".js-media-sublist").swiper != null
	//	) {
	//		document.querySelector(".js-media-sublist").swiper.destroy();
	//	}

	//	if (!newMediaSub) return;

	//	const parentSub = newMediaSub.parentElement;

	//	parentSub.prepend(newMediaSub);

	//	window.setTimeout(() => {
	//		parentSub.scroll(0, 0);
	//	});

	//	if (document.querySelector(".js-media-sublist")) {
	//		subSliderInit();
	//		updatethumbnail();
	//	}
	//}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value")
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);

				const colorNameSource = html.querySelectorAll(
					`.ColorName-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const colorNameDestination = document.querySelectorAll(
					`.ColorName-${this.dataset.section}`
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden")
					);
				}

				if (colorNameSource && colorNameDestination) {
					colorNameDestination.forEach(function (item, index) {
						item.innerHTML = colorNameSource[index].innerHTML;
					});
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === ""
					);

				const addButtonUpdated = html.getElementById(
					`ProductSubmitButton-${sectionId}`
				);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
					window.variantStrings.soldOut
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelectorAll('[name="add"] > span');
		const quantityInput = productForm.querySelector('.product-parameters__variant--quantity quantity-input');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) {
				addButtonText.forEach((elem) => {
					elem.innerHTML = `${text}`;
				});
			}
			if (quantityInput) {
				//quantityInput.style.display = "none";
				quantityInput.setAttribute("disabled", "disabled");
				quantityInput.classList.add("disabled-input");
			}
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.forEach((elem) => {
				elem.innerHTML = `${window.variantStrings.addToCart}`;
			});
			if (quantityInput) {
				//quantityInput.style.display = "block";
				quantityInput.removeAttribute("disabled");
				quantityInput.classList.remove("disabled-input");
			}
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const addButton = button.querySelector('[name="add"]');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		if (!addButton) return;
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
	constructor() {
		super();
	}

	loadContent() {
		super.loadContent();

		Shopify.loadFeatures([
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}

	setupModelViewerUI(errors) {
		if (errors) return;

		this.modelViewerUI = new Shopify.ModelViewerUI(
			this.querySelector("model-viewer")
		);

		const $this = this;

		this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
			"click",
			function () {
				if (
					$this
						.closest(".swiper")
						.swiper.slides[
							$this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
				) {
					if (
						!$this
							.closest(".swiper")
							.swiper.slides[
								$this.closest(".swiper").swiper.activeIndex
							].querySelector("model-viewer")
							.classList.contains("shopify-model-viewer-ui__disabled")
					) {
						if (
							$this
								.querySelector(".shopify-model-viewer-ui__button")
								.hasAttribute("hidden")
						) {
							$this.closest(".swiper").swiper.params.noSwiping = true;
							$this.closest(".swiper").swiper.params.noSwipingClass =
								"swiper-slide";
						}
					}
				}
			}
		);

		this.querySelector(
			".shopify-model-viewer-ui__controls-overlay"
		).addEventListener("click", function () {
			if (
				!$this
					.querySelector(".shopify-model-viewer-ui__button")
					.hasAttribute("hidden")
			) {
				$this.closest(".swiper").swiper.params.noSwiping = false;
			}
		});
	}
}
customElements.define("product-model", ProductModel);

(function () {
	const selectDropDown = () => {
		$(".product-form__input--dropdown").each(function () {
			const elListItem = $(this).find(".dropdown-select ul li");
			const elItem = $(this).find(".dropdown-select ul");
			const selectedText = $(this).find(".dropdown-select .select-label");

			selectedText.on("click", function (e) {
				elItem.toggleClass("active");
				if (elItem.hasClass("active")) {
					e.stopPropagation();
					$(document).click(function () {
						elItem.removeClass("active");
					});
				}
			});

			elListItem.on("click", function () {
				if (!$(this).find("input").hasClass("disabled")) {
					selectedText.text($(this).text()).attr("title", $(this).text());
				}
				elItem.removeClass("active");
				document.activeElement.blur();
			});
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		selectDropDown();
		document.addEventListener("shopify:section:load", function () {
			selectDropDown();
		});
	});
})();

// Product slider

(function () {
	const productSlider = () => {
		const productSliders = document.querySelectorAll(".section-slider");
		if (!productSliders.length) return;
		productSliders.forEach((slider) => {
			if (slider.classList.contains("slider_started")) return;

			slider.classList.add("slider_started");
   			const sectionId = slider.dataset.id;
    		const perRow = +slider.dataset.perRow;
    		const mobile = +slider.dataset.mobile;
			let perRowTablet;
			let perRowDesktop;
			let perRowLarge;
			const speed = slider.dataset.speed * 1000;
			const delay = slider.dataset.delay * 1000;
			const autoplay = slider.dataset.autoplay === "true";
			const stopAutoplay = slider.dataset.stopAutoplay === "true";
			const showArrows = slider.dataset.showArrows === "true";
			let autoplayParm = {};
			let arrowsParm = {};
			let PerView = 0.2;
			if (perRow == 2) {
				PerView = 0.6;
			}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}
			if (showArrows) {
				arrowsParm = {
					navigation: {
						nextEl: `#${sectionId} .swiper-btn--next`,
						prevEl: `#${sectionId} .swiper-btn--prev`,
					},
					pagination: {
						el: `#${sectionId} .products-slider-pagination`,
						clickable: true,
					},
				};
			}
			const wrapper = slider.querySelector(".popular-product__wrapper");
			if (!wrapper) return;

			const containerOuter = (document.body.offsetWidth - wrapper.offsetWidth) / 2;

			const paginationEl = slider.querySelector(".swiper-pagination");
			if (paginationEl) {
				paginationEl.style.paddingLeft = `${containerOuter}px`;
			} else {
				console.warn('Element not found or containerOuter is invalid', {
					sectionId,
					containerOuter,
				})

			}
			const buttonNext = document.querySelector(
				`#${sectionId} .swiper-button-next`
			);
			const buttonPrev = document.querySelector(
				`#${sectionId} .swiper-button-prev`
			);
			if (buttonNext && buttonPrev) {
				if (window.innerWidth >= 1200) {
					const buttonOffset = +containerOuter - 21;

					buttonNext.style.right = `${buttonOffset}px`;
					buttonPrev.style.left = `${buttonOffset}px`;
				} else {
					buttonNext.style.right = `${containerOuter + 21}px`;
					buttonPrev.style.left = `${containerOuter + 21}px`;
				}
			}

			const sectionHeader = document.querySelector(
				".section-slider .popular-product__wrapper"
			);
			let columnGaps = (perRow - 1) * 16;
			let oneCard = (sectionHeader.offsetWidth - columnGaps) / perRow;
			let perViewRightOffset = +((containerOuter * 2) / oneCard).toFixed(3);

			perViewRightOffset =
				+((containerOuter * 2) / oneCard).toFixed(3) -
				+(perViewRightOffset / oneCard) * 16;

			if (perRow == 1) {
				perRowTablet = perRowDesktop = perRowLarge = 1 + perViewRightOffset;
			} else {
				let columnGapsTablet = (2 - 1) * 16;
				let columnGaps = (3 - 1) * 16;
				let oneCard = (sectionHeader.offsetWidth - columnGaps) / 3;
				let oneCardTablet = (sectionHeader.offsetWidth - columnGapsTablet) / 2;

				let perViewRightOffsetDekstop =
					+((containerOuter * 2) / oneCard).toFixed(3) -
					+(perViewRightOffset / oneCard) * 16;
				let perViewRightOffsetTablet =
					+((containerOuter * 2) / oneCardTablet).toFixed(3) -
					+(perViewRightOffset / oneCardTablet) * 16;

				perRowTablet = 2 + perViewRightOffsetTablet;
				perRowDesktop = 3 + perViewRightOffsetDekstop;
				perRowLarge = perRow + perViewRightOffset;
			}
			if (perRow == 2) {
				perRowTablet = perRowDesktop = perRowLarge = 2 + perViewRightOffset;
			}

			let swiperParms = {
				speed,
				slidesPerView: mobile,
				slidesOffsetBefore: containerOuter,
				keyboard: true,
				mousewheel: { forceToAxis: true },
				breakpoints: {
					576: {
						slidesPerView: perRowTablet + PerView,
					},
					750: {
						slidesPerView: perRowTablet + PerView,
					},
					990: {
						slidesPerView: perRowDesktop + PerView,
					},
					1200: {
						slidesPerView: +perRow + perViewRightOffset + PerView,
					},
					1800: {
						slidesPerView: perRowLarge + PerView,
					},
					2000: {
						slidesPerView: perRowLarge + PerView,
					},
				},
				...arrowsParm,
				pagination: {
					el: slider.querySelector(".products-slider-pagination"),
					clickable: true,
				},
			};

		if (autoplay) {
			swiperParms.autoplay = {
				delay,
				pauseOnMouseEnter: stopAutoplay,
				disableOnInteraction: false,
			};
		}

   		slider.swiperInstance = new Swiper(slider.querySelector(".swiper"), swiperParms);
  	});
};

	function toBoolean(string) {
		return string === "true" ? true : false;
	}
	if (document.querySelector("product-recommendations") !== null) {
		const initslider = setInterval(() => {
			if (
				document
					.querySelector("product-recommendations")
					.querySelector(".swiper") !== null
			) {
				if (
					document
						.querySelector("product-recommendations")
						.querySelector(".swiper")
						.classList.contains("swiper-initialized")
				) {
					clearInterval(initslider);
				}
				productSlider();
			}
		}, 100);
	}
	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		document.addEventListener("shopify:section:load", function () {
			productSlider();
		});
	});
	window.addEventListener("resize", function () {
		document.querySelectorAll(".section-slider").forEach((slider) => {
			if (slider.swiperInstance) {
				slider.swiperInstance.destroy(true, true);
				slider.swiperInstance = null;
			}
			slider.classList.remove("slider_started");
		});

		productSlider();
	});
})();

(function () {
	const initDrawerAccordion = () => {
		$(".drawer__accordion-title").click(function () {
			if (!$(this).hasClass("active")) {
				$(".drawer__accordion-title.active").removeClass("active");
				$(this).addClass("active");
				$(".drawer__accordion-content").stop().slideUp(300);
				$(this)
					.siblings(".drawer__accordion-content")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".drawer__accordion-content").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		initDrawerAccordion();
		document.addEventListener("shopify:section:load", function () {
			initDrawerAccordion();
		});
	});
})();

(function () {
	let image = document.querySelectorAll(".data-alt img");
	image &&
		image.forEach((img, index) => {
			img.alt = "Video background";
		});
})();

(function () {
	const animatedText = () => {
		document.querySelectorAll(".animated-text").forEach((animatedText) => {
			const text = animatedText.dataset.text;

			animatedText.innerHTML = text
				.split(/(\s+)/)
				.map((chunk) => {
					if (chunk.trim() === "") {
						//return '<span class="space">&nbsp;</span>';
						return;
					}
					return `<span class="word">${[...chunk]
						.map(
							(letter) =>
								`<span class="letter_wrapper"><span class="letter">${letter}</span></span>`
						)
						.join("")}</span>`;
				})
				.join("");

				const words = animatedText.querySelectorAll('.word');
				words.forEach((word, index) => {
					const lastLetterWrapper = word.querySelector('.letter_wrapper:last-child');
					if (lastLetterWrapper && index < words.length - 1) {
						const space = document.createElement('span');
						space.classList.add('space');
						space.innerHTML = '&nbsp;';
						word.appendChild(space);
					}
				});

			const letters = animatedText.querySelectorAll(".letter, .space");

			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						letters.forEach((letter, index) => {
							setTimeout(() => {
								letter.classList.add("visible");
							}, index * 70);
						});
						observer.disconnect();
					}
				},
				{ threshold: 0.1 }
			);

			observer.observe(animatedText);
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		animatedText();
		document.addEventListener("shopify:section:load", function () {
			animatedText();
		});
	});
})();

//(function () {
//	const animatedText = () => {
//		// Function to wrap each word and letters within a word
//		const wrapLetters = (node) => {
//			if (node.nodeType === Node.TEXT_NODE) {
//				// If it's a text node and consists only of spaces, remove it
//				if (!node.textContent.trim()) {
//					return "";
//				}
//				// Split the text into words and letters
//				return node.textContent
//					.split(" ") // Split by spaces
//					.map((word) => {
//						if (word === "") {
//							return `<span class="space">&nbsp;</span>`; // Keep space as a span
//						}
//						// Wrap each word in a span and each letter within that word
//						return `<span class="word">${[...word]
//							.map((char) => `<span class="letter_wrapper"><span class="letter">${char}</span></span>`)
//							.join("")}</span>`;
//					})
//					.join(" ");
//			} else if (node.nodeType === Node.ELEMENT_NODE) {
//				// If the element is empty (no content), skip it
//				if (!node.innerHTML.trim()) {
//					return "";
//				}
//				const tagName = node.tagName.toLowerCase();
//				const attributes = [...node.attributes]
//					.map((attr) => `${attr.name}="${attr.value}"`)
//					.join(" ");
//				// Recursively process the element's content
//				const wrappedContent = Array.from(node.childNodes)
//					.map(wrapLetters)
//					.join("");
//				if (!wrappedContent.trim()) {
//					return ""; // Skip if the processed content is empty
//				}
//				// Rebuild the tag with wrapped content inside it
//				return `<${tagName} ${attributes}>${wrappedContent}</${tagName}>`;
//			}
//			return ""; // Ignore other types of nodes
//		};

//		// Main function to process all elements with the class .animated-text
//		document.querySelectorAll(".animated-text").forEach((animatedText) => {
//			// Save the original content of the element
//			const originalContent = animatedText.innerHTML;

//			// Process the text including nested tags
//			animatedText.innerHTML = Array.from(
//				document.createRange().createContextualFragment(originalContent).childNodes
//			)
//				.map(wrapLetters)
//				.join("");

//			// Find all letters and spaces
//			const elements = animatedText.querySelectorAll(".letter, .space");

//			// Observer for text appearance
//			const observer = new IntersectionObserver(
//				([entry]) => {
//					if (entry.isIntersecting) {
//						elements.forEach((element, index) => {
//							setTimeout(() => {
//								element.classList.add("visible");
//							}, index * 100); // Adding a delay to animate each letter
//						});
//						observer.disconnect();
//					}
//				},
//				{ threshold: 0.1 }
//			);

//			observer.observe(animatedText);
//		});
//	 };
//	 document.addEventListener("DOMContentLoaded", function () {
//		animatedText();
//		document.addEventListener("shopify:section:load", function () {
//			animatedText();
//		});
//	});
//})();

(function () {
	const initAnimated = () => {
		const blocks = document.querySelectorAll(".animated-block:not(.visible)");

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const block = entry.target;
						block.classList.add("visible");
						observer.unobserve(block);
					}
				});
			},
			{ threshold: 0.1 }
		);

		blocks.forEach((block) => {
			observer.observe(block);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		initAnimated();
		document.addEventListener("shopify:section:load", function () {
			initAnimated();
		});
	});
})();

const toggleButton = document.querySelector(".button_write");
if (toggleButton) {
	toggleButton.addEventListener("click", function () {
		const modal = document.querySelector(".comment-form");
		modal.classList.toggle("active");
	});
}

// Buttons animation

function buttonHoverEffects() {
	if (window.innerWidth < 1200) return;
	function wrapLetters(element) {
		const text = element.textContent.trim();
		element.innerHTML = "";

		const wrapperSpan = document.createElement("span");
		wrapperSpan.className = "wrapper";

		Array.from(text).forEach((char, charIndex) => {
			const charSpan = document.createElement("span");
			charSpan.className = "char";
			charSpan.textContent = char;
			charSpan.style.setProperty("--char-index", charIndex + 1);
			wrapperSpan.appendChild(charSpan);
		});

		element.appendChild(wrapperSpan);
	}

	document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
}

document.addEventListener("DOMContentLoaded", buttonHoverEffects);
document.addEventListener("shopify:section:load", buttonHoverEffects);


document.addEventListener("DOMContentLoaded", function () {
  const mainSlider = document.querySelector(".js-media-list")?.swiper;
  const thumbsSlider = document.querySelector(".js-media-sublist")?.swiper;

  if (!mainSlider || !thumbsSlider) return;

  // Sync click on thumbnail → main image
  thumbsSlider.slides.forEach((slide, index) => {
    slide.addEventListener("click", () => {
      mainSlider.slideTo(index);
    });
  });

  // Highlight active thumbnail
  mainSlider.on("slideChange", () => {
    thumbsSlider.slides.forEach(slide => slide.classList.remove("js-media-subitem-thumb-active"));
    const activeIndex = mainSlider.realIndex;
    const activeSlide = thumbsSlider.slides[activeIndex];
    if (activeSlide) activeSlide.classList.add("js-media-subitem-thumb-active");
  });
});
